<template>
    <div>
        <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
            <v-container class="contain-width">
                <v-row>
                    <v-col
                            cols="12"
                            md="8"
                            offset-md="2"
                    >
                        <h1 class="md-display-2 white--text mb-6">{{ $t('headings.Verifying email address') }}</h1>
                        <v-card
                                class="mx-auto form-card"
                                outlined
                        >

                            <v-card-text class="text--primary">

                                <p v-if="spin && invalid === false && authenticated()">{{ $t("Verifying email address") }} <v-icon>mdi mdi-36px mdi-spin mdi-loading</v-icon></p>
                                <div v-else-if="authenticated() === false">
                                    <p>{{ $t("Please login to complete your email verification") }}.</p>
                                    <ValidationObserver ref="observer">
                                        <v-form v-model="valid" @submit.prevent="handleSubmit">

                                            <ValidationProvider vid="email" :name="$t('labels.Email')" rules="required" v-slot="{ errors }">
                                                <v-text-field
                                                        v-model="email"
                                                        :error-messages="errors[0]"
                                                        :label="$t('labels.Email')"
                                                        required
                                                        autocapitalize="none"
                                                ></v-text-field>
                                            </ValidationProvider>

                                            <ValidationProvider vid="password" name="$t('labels.Password')" rules="required" v-slot="{ errors }">
                                                <v-text-field
                                                        v-model="password"
                                                        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                                        :type="showPassword ? 'text' : 'password'"
                                                        :error-messages="errors[0]"
                                                        :label="$t('labels.Password')"
                                                        required
                                                        autocapitalize="none"
                                                        @click:append="showPassword = !showPassword"
                                                ></v-text-field>
                                            </ValidationProvider>

                                            <div class="d-flex justify-end">
                                                <v-btn tile color="primary" elevation="0" @click="handleSubmit">{{ $t('buttons.Submit') }}</v-btn>
                                            </div>

                                        </v-form>
                                    </ValidationObserver>
                                </div>


                                <p v-else-if="verified" class="headline">{{ $t("Email address verified") }} <v-icon color="green">mdi mdi-36px mdi-check</v-icon></p>

                                <p v-else-if="invalid && authenticated()">{{ $t("The verification link has expired") }}. <router-link
                                        :to="{ name: 'verify' }"
                                        exact
                                >{{ $t('links.Request a new verification email') }}.</router-link></p>

                                <p v-else-if="invalid">{{ $t("The verification link has expired") }}. <router-link
                                        :to="{ name: 'login' }"
                                        exact
                                >{{ $t('links.Login') }}</router-link> {{ $t("and request a new verification email") }}.</p>

                            </v-card-text>

                            <v-card-actions>
                                <v-btn v-if="isOrganisation && verified" tile elevation="0" color="primary" @click="navigate('dashboard')">{{ $t('buttons.My Organisation') }}</v-btn>
<!--                                <v-btn v-else-if="verified" tile elevation="0" color="primary" @click="navigate('dependants')">Add Dependants</v-btn>-->
                            </v-card-actions>

                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>
    import axios from 'axios';

    import Footer from './Footer'
    import { store } from '../store';
    import { mapState, mapActions, mapGetters } from 'vuex'
    import {i18n} from "../i18n";

    export default {
        name: "Verified",
        components: {
            'Footer': Footer
        },
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('Verified'),
            htmlAttrs: {
              lang: i18n.locale
            }
          }
        },
        data () {
            return {
                spin: false,
                invalid: false,
                verified: false,
                email: '',
                password: '',
                valid: false,
                showPassword: false,
            }
        },
        methods: {
            ...mapActions('account', ['loginVerified', 'updateVerifiedAt']),
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            navigate(routeName) {
                this.$router.push({name: routeName})
            },
            authenticated () {
                return store.getters.isAuthenticated
            },
            async handleSubmit () {

                let observer = this.$refs.observer;

                const isValid = await observer.validate();

                if (isValid) {
                    const { email, password } = this;
                    if (email && password) {
                        this.loginVerified( {email, password}).then((user) => {
                            let url = decodeURI(this.$route.query.url);
                            let path = url.substring(url.indexOf('verify/') + 7)

                            //const user = this.user;

                            if (user && this.isAuthenticated) {

                                this.spin = true

                                let apiClient = axios.create({
                                    baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                                    headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
                                    withCredentials: true,
                                });

                                apiClient
                                    .get('/email/verify/' + path)
                                    .then(response => {
                                        console.log(response.status)
                                        if (response.status === 200) {
                                            this.updateVerifiedAt(response.data.email_verified_at)
                                            this.verified = true
                                            if (this.isOrganisation) {
                                                this.$router.push({name: 'dashboard'})
                                            }
                                            else {
                                                this.$router.push({name: 'account'})
                                            }
                                        }
                                        this.spin = false
                                    })
                                    .catch(error => {
                                        console.log(error)
                                        this.invalid = true
                                        this.spin = false
                                    })
                            }
                        });
                    }
                }

            }
        },
        computed: {
            ...mapState({
                user: state => state.account.user,
                brand: state => state.brand,
                brandName: state => state.brandName
            }),
            ...mapGetters(['isAuthenticated']),
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
            isOrganisation() {
                let user = this.user;

                if (user && user.roles && user.roles.includes('organisation')) {
                    return true
                }
                return false
            }
        },
        mounted () {
            this.$gtag.pageview({
                page_path: '/verified'
            })

            let url = decodeURI(this.$route.query.url);
            let path = url.substring(url.indexOf('verify/') + 7)

            const user = this.user;

            if (user && this.isAuthenticated) {

                this.spin = true

                let apiClient = axios.create({
                    baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                    withCredentials: true,
                });

                apiClient.get('/sanctum/csrf-cookie').then(() => {
                    apiClient
                        .get('/email/verify/' + path)
                        .then(response => {
                            console.log(response.status)
                            if (response.status === 200) {
                                this.updateVerifiedAt(response.data.email_verified_at)
                                this.verified = true
                                if (this.isOrganisation) {
                                    this.$router.push({name: 'dashboard'})
                                }
                                else {
                                    this.$router.push({name: 'account'})
                                }
                            }
                            this.spin = false
                        })
                        .catch(error => {
                            console.log(error)
                            this.invalid = true
                            this.spin = false
                        })
                })
            }
        },
    }
</script>

<style scoped>

</style>
